import { rooFetch } from "../common/rooFetch";

export const getHasInvite = async (emailId: string) => {
  const response = await rooFetch(`${window.RooConfig.API_URL}api/hospital/invite/${emailId}`);
  const json: { data: { hasInvite: boolean } } = await response.json();
  return json?.data.hasInvite ?? false;
};
